<template>
  <b-form-select 
    :options="[{label:'-- Kies een relatie --', value: null}].concat(items)" 
    :value="value"
    text-field="label"
    value-field="value"
    @change="$emit('input',$event)"
  />
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";

export default {
    mixins: [serviceMixin],
    props: {
        value: {
            type: Object,
            default: null
        },
        url: {
            type: String,
            default: '/relaties'
        }
    },
    data() {
        return {
            relaties: []
        }
    },
    computed: {
      items: function () {
      return this.relaties.map(function (item) {
        return {
          label: item.Naam,
          value: {
            naam: item.Naam,
            id: item.Id
          }
        };
      });
    },
    },
    mounted() {
      var vm = this;
      this.get(this.url)
        .then(function(response) {
          console.dir(response.data);
          vm.relaties = response.data.relaties;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
}
</script>